// Fired when a user authenticates. The access token and user ID
// are persisted as secure cookies in /middleware/session.js

export const LOG_IN = 'LOG_IN';

export const logIn = (accessToken, userID, uuid) => ({
	type: LOG_IN,
	accessToken,
	userID,
	uuid,
});

// Logs a user out. We specify a 'reason' (e.g. session timed out)
// so the next screen can display a confirmation message of
// why they were logged out.

export const logOutReasons = {
	TIMED_OUT: 'timedout',
	LOGGED_OUT: 'loggedout',
};

export const LOG_OUT = 'LOG_OUT';
export const logOut = (reason) => {
	return {
		type: LOG_OUT,
		reason,
	};
};

export const LOG_OUT_DEV = 'LOG_OUT_DEV';
export const logOutDev = (reason) => ({
	type: LOG_OUT_DEV,
	reason,
});

// Fired when an authenticated session begins. Note this differs
// from a LOG_IN, for example, this will fire if an already
// logged-in user has refreshed the page.

export const AUTH_SESSION_START = 'AUTH_SESSION_START';

export const authSessionStart = (userID, uuid) => ({
	type: AUTH_SESSION_START,
	userID,
	uuid,
});
